export default __webpack_public_path__ + "static/next-project-a81bb7e985ee06f25eca56c0551bd779.svg";